var _style, _defs, _path, _defs2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 601.69 333.67",
    style: {
      enableBackground: "new 0 0 601.69 333.67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000157274812629131806460000002094772887880881549_);fill:url(#SVGID_00000011023953961557442440000005082767859883025556_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000157274812629131806460000002094772887880881549_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000172442236338325907310000009916698425007920545_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000179619431147979474750000005667248057365578113_);fill:url(#SVGID_00000137116725454928071170000008297080625203071620_);}\n\t.st4{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M110.53,0v105.7h22.29V22.29h168.07c25.26,0,46.01,20.75,46.01,46.01v37.4h22.29v-37.4 c0-37.57-30.74-68.31-68.3-68.31H110.53z M178.83,333.67h240.49V229.55h-22.29v81.83h-218.2c-25.27,0-46.01-20.75-46.01-46.01 v-35.82h-22.29v35.82C110.53,302.94,141.26,333.67,178.83,333.67z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067215818551552819980000000875416364993006733_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.4789,
    y1: 46.9099,
    x2: 167.4265,
    y2: 321.5966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006205241,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000067215818551552819980000000875416364993006733_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168098116523595730900000013969793792952136068_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096743057438676269040000002752928004303837578_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.2516,
    y1: 7.588,
    x2: 155.2516,
    y2: 340.9218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006205241,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.53,
    style: {
      clipPath: "url(#SVGID_00000168098116523595730900000013969793792952136068_)",
      fill: "url(#SVGID_00000096743057438676269040000002752928004303837578_)"
    },
    width: 308.79,
    height: 333.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003818256475849450380000017597023579281781181_",
    gradientUnits: "userSpaceOnUse",
    x1: 1224.0272,
    y1: 6.771,
    x2: 1050.9747,
    y2: 281.4577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006205241,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000168098116523595730900000013969793792952136068_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000003818256475849450380000017597023579281781181_)"
    },
    d: " M994.08-40.14v105.7h22.29v-83.41h168.07c25.26,0,46.01,20.75,46.01,46.01v37.4h22.29v-37.4c0-37.57-30.74-68.31-68.3-68.31 H994.08z M1062.38,293.53h240.49V189.41h-22.29v81.83h-218.2c-25.27,0-46.01-20.75-46.01-46.01v-35.82h-22.29v35.82 C994.08,262.8,1024.81,293.53,1062.38,293.53z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M485.64,119.47v96.32h-18.3l-48.02-58.48v58.48h-22.01v-96.32h18.44l47.88,58.48v-58.48H485.64z  M346.91,119.47h22.29v96.32h-22.29V119.47z M258.53,119.47h22.29v78.15h48.29v18.16h-70.59V119.47z M238.95,197.62v18.16h-84.21 v-14.45l52.84-63.71h-51.74v-18.16h81.04v14.45l-52.7,63.71H238.95z M110.53,119.47h22.29v96.32h-22.29V119.47z M48.16,199 c5.87,0,10.3-0.96,13.28-2.89c2.98-1.93,4.47-4.91,4.47-8.95c0-7.98-5.92-11.97-17.75-11.97h-26V199H48.16z M22.15,136.26v22.7 H44.3c5.5,0,9.68-0.96,12.52-2.89c2.85-1.93,4.26-4.77,4.26-8.53c0-3.76-1.42-6.58-4.26-8.46c-2.85-1.88-7.02-2.82-12.52-2.82 H22.15z M552.27,185.01l22.41,30.78H600l-35.08-48.16l-12.66-17.38l-22.42-30.78h-25.31l35.07,48.16l-35.07,48.16h25.31 L552.27,185.01z M70.72,165.7c5.51,1.74,9.82,4.66,12.93,8.74c3.12,4.08,4.68,9.1,4.68,15.07c0,8.44-3.28,14.93-9.84,19.47 c-6.56,4.54-16.12,6.81-28.7,6.81H0v-96.32h47.06c11.74,0,20.75,2.25,27.04,6.74c6.28,4.49,9.42,10.59,9.42,18.3 c0,4.68-1.13,8.85-3.37,12.52C77.9,160.7,74.76,163.59,70.72,165.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103242778727152052650000012938213079632236198_",
    d: "M600,119.47h-17.02c-5.38,0-10.01,2.35-13.18,6.7 l-17.53,24.07h17.02c5.38,0,10.01-2.36,13.18-6.71L600,119.47z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100379440404037530240000015585964357252924852_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.2676,
    y1: 134.8601,
    x2: 600.0005,
    y2: 134.8601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103242778727152052650000012938213079632236198_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000100379440404037530240000015585964357252924852_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110444606568072724830000014197467000851013307_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103242778727152052650000012938213079632236198_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046323395914425821070000003756645596546744999_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.2676,
    y1: 134.8601,
    x2: 600.0005,
    y2: 134.8601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 552.27,
    y: 119.47,
    style: {
      clipPath: "url(#SVGID_00000110444606568072724830000014197467000851013307_)",
      fill: "url(#SVGID_00000046323395914425821070000003756645596546744999_)"
    },
    width: 47.73,
    height: 30.78
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M467.42,318.9c0-7.07,5.24-11.7,11.82-11.7s11.82,4.63,11.82,11.7c0,6.95-5.24,11.94-11.82,11.94 S467.42,325.84,467.42,318.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M563.19,292.46v37.4H545.4v-8.16c-3.53,5.97-10.36,9.14-19.98,9.14c-15.35,0-24.49-8.53-24.49-19.86 c0-11.57,8.16-19.62,28.14-19.62h15.11c0-8.16-4.87-12.91-15.11-12.91c-6.94,0-14.13,2.31-18.89,6.09l-6.82-13.28 c7.19-5.12,17.79-7.92,28.27-7.92C551.61,263.34,563.19,272.6,563.19,292.46z M544.18,309.15v-6.7h-13.04 c-8.89,0-11.7,3.29-11.7,7.68c0,4.75,4.02,7.92,10.72,7.92C536.51,318.04,541.99,315.12,544.18,309.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M578.05,244.57c0-5.97,4.75-10.6,11.82-10.6c7.07,0,11.82,4.39,11.82,10.23c0,6.34-4.75,10.97-11.82,10.97 C582.8,255.17,578.05,250.54,578.05,244.57z M580.37,264.31h19.01v65.55h-19.01V264.31z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.2fa212ad09cb571f326770ab86c60a07.svg";
export { ForwardRef as ReactComponent };